import { Avatar, Flex, Text } from '@chakra-ui/react'
import React from 'react'

export type ChatMessage = {
  text: string
  from?: string
  time?: Date
}

type ChatMessageItemTypeProps = {
  item: ChatMessage
}

export const ChatMessageItemType: React.FC<ChatMessageItemTypeProps> = ({ item }) => {
  if (item.from === 'agent') {
    return (
      <Flex w="100%" justify="flex-end" mb="10px">
        <Flex bg="blue.400" color="#000" minW="100px" maxW="250px" p="3" borderRadius="12px" mr="8px" h="fit-content">
          <Text fontSize="12px" color="#fff" fontWeight="400">
            {item.text}
          </Text>
        </Flex>
        <Avatar bg="blue.400" borderRadius="8px" width="40px" height="40px" marginTop="auto" mt="2px" />
      </Flex>
    )
  }
  return (
    <Flex w="100%" mb="10px">
      <Avatar bg="#F1F1F1" borderRadius="8px" width="40px" height="40px" marginTop="auto" mt="2px" />
      <Flex bg="#F1F1F1" color="#000" minW="100px" maxW="250px" p="3" borderRadius="12px" ml="8px" h="fit-content">
        <Text fontSize="12px" color="#000" fontWeight="400">
          {item.text}
        </Text>
      </Flex>
    </Flex>
  )
}
